import React, { Component } from 'react';
import { connect } from "react-redux";
import NewQuestion from './new-question';

class EditQuestion extends Component {

    constructor(props) {
        super(props);

        
    }

    render() {
        return (<NewQuestion {...this.props} />);
    }

}
function mapStateToProps(state) {
    return { ...state };
}

export default connect(mapStateToProps)(EditQuestion);
